module.exports = __webpack_public_path__ + "img/menu-icon-contacts.3f7df6bf.svg";